export default __webpack_public_path__ + "static/media/preethi.fa569503.jpeg";